import { alpha } from '@mui/material';

import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    iconButton: {
      border: '1px solid #cccccc',
      height: '24px',
      fontSize: '15px',
      borderRadius: '2px',
      color: '#336699',
      fontWeight: 'normal',
      letterSpacing: 'normal',
      backgroundColor: '#e9e9ed',
      fontFamily: 'arial, helvetica, sans-serif',
      textTransform: 'capitalize',
      '&:hover': {
        backgroundColor: '#d0d0d7',
      },
      '& .MuiButton-startIcon': {
        '& .fa': {
          fontSize: 'inherit',
        },
      },
    },
    help: {
      color: legacyColors.icon.help,
      fontSize: '18px',
      position: 'relative',
      padding: '0 6px',
      border: 'none',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      height: 'auto',
      '&:hover': {
        backgroundColor: alpha(legacyColors.icon.help, 0.1),
      },
    },
  };
};
